// extracted by mini-css-extract-plugin
export default {"container":"Aijgn7","details":"FJTyLl","opaque":"KTsQL0"};